<template>
  <div class="banner-wrap">
      <div class="banner-bg"></div>
      <div class="banner">
          <div class="banner-tx"></div>
          <div class="banner-name">张昕宇</div>
          <div class="banner-gh">普通用户 ｜ 工号200302058766</div>
          <div class="banner-xy">教学科研单位/信息与通信工程学院/信息理论技术数据中心</div>
      </div>
      <div class="banner-links">
          <div class="banner-links-item" v-on:click="tourl(1)">
              <div class="banner-links-item1 banner-links-item-bg1"></div>
              <div class="banner-links-item2">资产管理系统</div>
          </div>
          <div class="banner-links-item" v-on:click="tourl(2)">
              <div class="banner-links-item1 banner-links-item-bg2"></div>
              <div class="banner-links-item2">采购管理系统</div>
          </div>
          <div class="banner-links-item" v-on:click="tourl(3)">
              <div class="banner-links-item1 banner-links-item-bg3"></div>
              <div class="banner-links-item2">房产管理系统</div>
          </div>
          <div class="banner-links-item" v-on:click="tourl(4)">
              <div class="banner-links-item1 banner-links-item-bg4"></div>
              <div class="banner-links-item2">实验室管理系统</div>
          </div>
          <div class="banner-links-item" v-on:click="tourl(5)">
              <div class="banner-links-item1 banner-links-item-bg5"></div>
              <div class="banner-links-item2">资产大数据分析平台</div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  components:{
  },
  methods:{
      tourl(index){
          if(index == 1){
              window.open('https://gz.btbu.edu.cn/zcgl/','_blank');
          }
          else if(index == 2){
              window.open('https://cg.btbu.edu.cn/','_blank');
          }
          else if(index == 3){
               window.open('https://gz.btbu.edu.cn/fcgl/','_blank');
          }
          else if(index == 4){
              window.open('https://gz.btbu.edu.cn/lab-platform/login','_blank');
          }
          else if(index == 5){
              window.open('https://gz.btbu.edu.cn/bi/','_blank');
          }
          
      }
  }
}
</script>

<style lang="less" scoped>
.banner-wrap{
    width: 100%;
    height: 367px;
    position: relative;
    .banner-bg{
        background:  none no-repeat center center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: 100% 367px;
        background-image:url('../../../static/statistics/山背景@2x.png');
        left: 0;
        top: 0;
        width: 100%;
        height: 367px;
        overflow: hidden;
        z-index: -1;
    }
    .banner{
        position: absolute;
        width: 450px;
        left: 50%;
        margin-left: -225px;
        top: 63px;
        .banner-tx{
            height: 70px;
            width: 70px;
            margin: 0 auto;
            background: url('../../../static/statistics/头像@2x.webp');
            background-size: 70px 70px;
            margin-bottom: 20px;
        }
        .banner-name{
            height: 22px;
            font-family: PingFangSC-S0pxibold;
            font-weight: 600;
            font-size: 16px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            margin-bottom: 16px;
            line-height: 22px;
        }
        .banner-gh{
            height: 20px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: 20px;
            text-align: center;
            margin-bottom: 16px;
        }
        .banner-xy{
            height: 20px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: 20px;
            text-align: center;
        }
    }
    .banner-links{
        width: 1200px;
        height: 156px;
        background: #FFFFFF;
        box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
        border-radius: 4px;
        position: absolute;
        left: 50%;
        margin-left: -600px;
        bottom: -88px;
        .banner-links-item{
            float: left;
            width: 240px;
            cursor: pointer;
        }
        .banner-links-item1{
            width: 46px;
            height: 46px;
            margin: 0 auto;
            margin-top: 33px;
            margin-bottom: 14px;
        }
        .banner-links-item-bg1{
            background: url('../../../static/statistics/资产管理系统@2x.webp');
            background-size: 46px 46px;
        }
        .banner-links-item-bg2{
            background: url('../../../static/statistics/采购管理系统@2x.webp');
            background-size: 46px 46px;
        }
        .banner-links-item-bg3{
            background: url('../../../static/statistics/房产管理系统@2x.webp');
            background-size: 46px 46px;
        }
        .banner-links-item-bg4{
            background: url('../../../static/statistics/实验室管理系统@2x.webp');
            background-size: 46px 46px;
        }
        .banner-links-item-bg5{
            background: url('../../../static/statistics/资产大数据分析平台@2x.webp');
            background-size: 46px 46px;
        }
        .banner-links-item2{
            height: 25px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 18px;
            color: #424242;
            letter-spacing: 0;
            line-height: 25px;
            text-align: center;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/banner.vue